import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_TABLE = Symbol('table');

export const TABLE_FILTER_SETS_URL = ':namespace/filter_sets/:filterName/list_or_create';
export const TABLE_FILTER_COLUMN_URL = ':namespace/filter_sets/:filterId/filter_segments/:columnName';
export const TABLE_ADD_FILTER_COLUMN_URL = ':namespace/filter_sets/:filterId/filter_segments/:columnName/add';
export const TABLE_REMOVE_FILTER_COLUMN_URL = ':namespace/filter_sets/:filterId/filter_segments/:columnName/remove';

export const TABLE_FILTER_SETS_QUERY_KEY = 'tables.filter-sets';
export const TABLE_FILTER_COLUMN_QUERY_KEY = 'tables.filter-column';
export const TABLE_NEW_FILTER_SETS_MUTATION_KEY = 'tables.new-filter-sets';
export const TABLE_ADD_FILTER_COLUMN_MUTATION_KEY = 'tables.add-filter-column';
export const TABLE_REMOVE_FILTER_COLUMN_MUTATION_KEY = 'tables.remove-filter-column';

export const TABLES_PERMISSIONS = {
  FILTERSETS_SHOW: new Permission(
    PermissionsList.admin.FILTERSETS_SHOW,
    PermissionsList.affiliate.FILTERSETS_SHOW,
  ),
};

export const QA_TABLES = {
  root: 'table',
  title: 'table-title',
  filterButton: 'table-filter-button',
  refreshButton: 'table-refresh-button',
  noData: 'table-no-data',

  headRow: 'table-head-row',
  headCheckboxAll: 'table-head-checkbox-all',
  headActionsButton: 'table-head-actions-button',
  headActionItem: 'table-head-action-item',
  headCell: 'table-head-cell',
  headCellSort: 'table-head-cell-sort',

  bodyRow: 'table-body-row',
  bodyRowCheckbox: 'table-body-row-checkbox',
  bodyRowCell: 'table-body-row-cell',
  bodyRowTotal: 'table-body-row-total',

  pagination: 'table-pagination',
  paginationPageInput: 'table-pagination-page-input',
  paginationPrev: 'table-pagination-prev',
  paginationNext: 'table-pagination-next',

  mobileSortMenu: 'table-mobile-sort-menu',
  mobileSearchMenu: 'table-mobile-search-menu',
  mobilePreviewMenu: 'table-mobile-preview-menu',
  mobilePreviewMenuItem: 'table-mobile-preview-menu-item',
  mobileToggleAll: 'table-mobile-toggle-all',
  mobileAccordionItemToggle: 'table-mobile-accordion-item-toggle',

  filterPresetButton: 'table-filter-preset',
  filterPresetAddButton: 'table-filter-preset-add',
  filterColumn: 'table-filter-column',
  filterColumnClear: 'table-filter-column-clear',
  filterApply: 'table-filter-apply',
  filterClear: 'table-filter-clear',

  filterCompareRoot: 'filter-compare-root',
  filterCompareAddOrRemove: 'filter-compare-add-or-remove',
  filterCompareRow: 'filter-compare-row',
  filterCompareRowCondition: 'filter-compare-row-condition',
  filterCompareRowValue: 'filter-compare-row-value',
  filterCompareRowClear: 'filter-compare-row-clear',

  filterDateRangeRoot: 'filter-date-range-root',
  filterDateRangeClear: 'filter-date-range-clear',
};
